import { useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import CarrierGuardDashboardService from '../services/CarrierGuardDashboardService';

export const CARRIER_GUARD_DASHBOARD_QUERY_KEY = '3rd-party-management-fetch-carrier-guard-dashboard';

const useCarrierGuardDashboard = ({
    t,
}) => {
    return useQuery({
        queryKey: [CARRIER_GUARD_DASHBOARD_QUERY_KEY],
        queryFn: async () => {
            const service = CarrierGuardDashboardService.getInstance();

            return await service.fetchDashboard();
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: () => {
            toast(t('An error occurred while fetching dashboard data.'), {
                type: 'error',
            });
        },
    });
};

export default useCarrierGuardDashboard;
